import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  changeCurrentMemberMenu,
  // screenChange
} from "../../store/screenSlice";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { TextField } from "@mui/material";
import {
  resetEvent,
  updateEvent,
  deleteCostInfo,
  deleteLocationInfo,
  updateEventNoFormat,
  clearMaterialURL,
} from "../../store/eventApiSlice";
import { DevTool } from "@hookform/devtools";
import CurrencyInput from "react-currency-input-field";
import deleteIcon from "./../../Images/Delete.png";
import {
  useForm,
  Controller,
  useFormContext,
  Merge,
  FieldError,
  FieldErrorsImpl,
} from "react-hook-form";
import { Button, Label, PageLink } from "../StyledComp/StyledComp";
import { DateValidationError } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { all } from "axios";
import { invalid } from "moment";
import ReactModal from "react-modal";
import MemberServices from "../../services/MemberServices";
import EventServices from "../../services/EventServices";
import AddCostInfo from "./AddCostInfo";
import AddLocationInfo from "./AddLocationInfo";
import { screenConfig } from "../../config/screenConfig";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { TodaySharp } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import * as routeConfig from "../../config/routes";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { FileRejection, useDropzone } from "react-dropzone";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import DeleteIcon from "@mui/icons-material/Delete";
import YesNoAlert from "../utilityComponents/YesNoAlert";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import moment from "moment";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import { FormatUtils } from "../util/FormatUtils";

type FormValues = {
  EventName: string;
  Description: string;
  UniqueEventId: string;
  EventType: string;
  EventCategory: string;
  TestDateTime: string;
  StartDateTime: string;
  EndDateTime: string;
  EarlyBirdBy: string;
  Available: number;
  AvailableOnline: string;
  SponsorName: string;
  RegistrationLink: string;
  ZoomMeetingID: string;
  ZoomRegLink: string;
  DECredits: number;
  DEEnchEthics: number;
  PACredits: number;
  PAEthics: number;
  NJCredits: number;
  NJEthics: number;
  Comments: string;
  MaterialLink: string;
  Location: string;
  LocationCost: number;
  CostName: string;
  CostNameCost: number;
};

type FormValues1 = {
  CostName: string;
  CostNameCost: number;
};

interface IConfiguration {
  [key: string]: any;
}

interface Cost {
  CostId: number | null;
  CostName: string | null;
  Cost: number | null;
}

interface AddFormValue {
  Location: string | null;
  Status: string | null;
}

const CreateEvent: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // dispatch(screenChange("Events"));

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const form = useForm<FormValues>();
  const Locationform = useForm<AddFormValue>();
  const formCost = useForm<FormValues1>({ mode: "onSubmit" });
  const { register, control, handleSubmit, formState, setValue } = form;
  const {
    register: locationRegister,
    control: locationControl,
    handleSubmit: locationHandleSubmit,
    formState: locationFormState,
    setValue: locationSetValue,
    reset,
  } = Locationform;
  const { errors } = formState;

  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const {
    register: registerCost,
    control: controlCost,
    handleSubmit: handleSubmitCost,
    formState: { errors: errorsCost },
    setValue: setValueCost,
  } = formCost;

  // const { errors: errorsCost } = formStateCost;

  const eventInfo = useSelector(
    (state: RootState) => state.eventapislice.event
  );

  // const [EventCostList, setEventCostList] = useState<Cost[] | null>(
  //   eventInfo.Costs
  // );

  const [materialUploadModalOpen, setMaterialUploadModalOpen] =
    useState<boolean>(false);
  const [YesNoAlertModalOpen, setYesNoAlertModalOpen] =
    useState<boolean>(false);

  const [error, setError] = React.useState<DateValidationError | null>(null);
  const [CostModalOpen, setCostModalOpen] = useState<boolean>(false);
  const [LocationModalOpen, setLocationModalOpen] = useState<boolean>(false);
  const [videoUploadModalOpen, setvideoUploadModalOpen] =
    useState<boolean>(false);

  /* ----use config list as temporary place holder for cost name  */
  const [costDesc, setcostDesc] = useState<IConfiguration>([]);

  const [uniqueEventId, setUniqueEventId] = useState<string>("");
  const [registrationLink, setRegistrationLink] = useState<string>("");
  const [materialLink, setMaterialLink] = useState<string>("");

  const [StartDateTime, setStartDateTime] = useState<Dayjs | null>(null);
  const [EndDateTime, setEndDateTime] = useState<Dayjs | null>(null);
  const [EarlyBirdBy, setEarlyBirdBy] = useState<Dayjs | null>(null);

  const [eventType, seteventType] = useState<string>();
  const [materialURL, setmaterialURL] = useState("");
  const [uploaded, setUploaded] = useState<number>(0);

  const [addLocationDialogOpen, setAddLocationDialogOpen] = useState(false);

  const openAddLocationDialog = () => {
    setAddLocationDialogOpen(!addLocationDialogOpen);
  };

  const closeAddLocationDialog = () => {
    setAddLocationDialogOpen(false);
  };

  useEffect(() => {
    dispatch(resetEvent());
  }, []);

  const onDocuDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      console.log("onDocuDrop-eventId:", eventInfo);
      if (fileRejections.length > 0) {
        alert("Only pdf files are allowed!");
      } else if (acceptedFiles.length > 0) {
        uploadMaterial(acceptedFiles[0]);
      }
      console.log(acceptedFiles);
    },
    [eventInfo]
  );

  const {
    getRootProps: getRootPropsDocu,
    getInputProps: getInputPropsDocu,
    isDragActive: isDragActiveDocu,
  } = useDropzone({
    onDrop: onDocuDrop,
    accept: {
      pdf: [".pdf"],
      // document: [".docx"],
    },
  });

  const handleFileUploadButtonClick = () => {
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement | null;
    if (fileInput) {
      fileInput.click();
    }
  };

  // Function to copy link to clipboard
  const copyToClipboard = () => {
    if (eventInfo && eventInfo.MaterialLink) {
      navigator.clipboard.writeText(eventInfo.MaterialLink).then(
        () => {
          toast("Link copied to clipboard!");
        },
        (err) => {
          toast("Failed to copy: ", err);
        }
      );
    }
  };

  const deleteMaterialURL = (YesorNo: boolean) => {
    console.log("deleteMaterialURL called:", YesorNo);
    if (YesorNo) {
      dispatch(clearMaterialURL());
      toast("Uploaded Material Deleted Succefully");
    }
    setYesNoAlertModalOpen(false);
  };

  const updateInput = (event: any): void => {
    console.log("key:", event.target.name, "value:", event.target.value);
    switch (event.target.name) {
      case "EventName":
        // setRegistrationLink(
        //   "http:limedia1.dsba.org/pubic/CLE/RegistrationForma/" +
        //     event.target.value.replace(/[^\w\s]/gi, "-") +
        //     ".pdf"
        // );
        setRegistrationLink(
          "https://www.dsba.org/event/" +
            FormatUtils.toUrlSlug(event.target.value)
        );
        dispatch(
          updateEvent({
            key: "RegistrationLink",
            value:
              "https://www.dsba.org/event/" +
              FormatUtils.toUrlSlug(event.target.value),
          })
        );
        break;
      case "UniqueEventId":
        setUniqueEventId(event.target.value.replace(/\s/g, ""));
        // setMaterialLink(
        //   "https:/www.dsba.org/materials/?Cleid=" +
        //     event.target.value.replace(/\s/g, "")
        // );
        // dispatch(
        //   updateEvent({
        //     key: "MaterialLink",
        //     value: materialURL,
        //   })
        // );
        break;
      case "EventType":
        seteventType(event.target.value);
        break;
      case "MaterialLink":
        setMaterialLink(event.target.value);
        break;
      case "AvailableOnline":
        dispatch(
          updateEvent({
            key: "AvailableOnline",
            value: event.target.checked ? 1 : 0,
          })
        );
        break;
      // case "videos":
      //   const formData = new FormData();
      //   formData.append("media", event.target.files[0]);
      //   formData.append("id", "17");
      //   uploadVideo(formData);
      //   break;
      default:
        break;
    }

    dispatch(
      updateEvent({
        key: event.target.name,
        value: event.target.value,
      })
    );
  };

  const updateTextField = (event: any): void => {
    dispatch(
      updateEvent({
        key: event.target.name,
        value: event.target.value,
      })
    );
  };

  const updateDateField = (passedDate: Dayjs, type: string) => {
    if (dayjs(passedDate).isValid()) {
      // // Get the timezone offset in minutes and convert to hours
      // const timezoneOffset = passedDate.utcOffset() / 60; // This will give you the offset in hours
      // // Format the offset as ±HH:MM
      // const timezoneString = `${timezoneOffset >= 0 ? "+" : "-"}${Math.abs(
      //   timezoneOffset
      // )
      //   .toString()
      //   .padStart(2, "0")}:00`;

      // // Format the date-time including the timezone offset
      // const formattedStartDateTime =
      //   passedDate.format("YYYY-MM-DDTHH:mm:ss") + timezoneString;

      console.log("PassedTime:", passedDate); //Sat Jul 27 2024 13:30:38 GMT+0530
      const passedDateUTCTime = dayjs
        .tz(passedDate, "America/New_York")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss");

      console.log("eventUTCTime:", passedDateUTCTime); // 2024-07-27T08:00:38

      dispatch(
        updateEvent({
          key: type,
          value: passedDateUTCTime,
          // value: formattedStartDateTime,
          // value: passedDate.format("YYYY-MM-DD HH:mm:ss"),
        })
      );
    }
    switch (type) {
      case "StartDateTime":
        if (passedDate.isValid()) {
          setValue("StartDateTime", passedDate.format("YYYY-MM-DDTHH:mm:ss"), {
            shouldDirty: true,
          });
          // setValue(
          //   "EndDateTime",
          //   passedDate.add(4, "hour").format("YYYY-MM-DDTHH:mm:ss"),
          //   {
          //     shouldDirty: true,
          //   }
          // );
          // dispatch(
          //   updateEvent({
          //     key: "EndDateTime",
          //     value: passedDate.add(4, "hour").format("YYYY-MM-DD HH:mm:ss"),
          //   })
          // );
        } else {
          console.log("Start DateTime invalid");
        }
        break;
      case "EndDateTime":
        if (passedDate.isValid()) {
          setValue("EndDateTime", passedDate.format("YYYY-MM-DDTHH:mm:ss"), {
            shouldDirty: true,
          });
        } else {
          console.log("EndDateTime invalid");
        }
        break;
      case "EarlyBirdBy":
        if (passedDate.isValid()) {
          setValue("EarlyBirdBy", passedDate.format("YYYY-MM-DDTHH:mm:ss"), {
            shouldDirty: true,
          });
        } else {
          console.log("EarlyBirdBy invalid");
        }
        break;
      default:
        console.log("default case");
        break;
    }
  };

  // const onAddCostItem = (e: any) => {
  //   console.log("onAddCostItem");
  //   console.log("onAddCostItem:", e);
  // };

  const onSubmit = async (d: any) => {
    // console.log("SUBMIT");

    console.log("onSubmit:", StartDateTime);

    const response = await EventServices.createEvent(eventInfo);
    console.log("response", response);
    if (response.data.data != null) {
      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Database Error");
        setAlertBody(response.data.errors[0].sqlMessage);
        return;
      }
      alert("Event Created successfully");
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      // navigate("/event", { replace: true });
      // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
      //  dispatch(screenChange("Events"));
      navigate(routeConfig.EVENT_URL, { replace: false });
    } else {
      alert(response.data.errors);
      console.log("error");
    }
  };

  const closeCostModal = (flag: boolean) => {
    console.log("isModelOpen:", CostModalOpen);
    setCostModalOpen(flag);
  };

  const closeLocationModal = (flag: boolean) => {
    console.log("isModelOpen:", LocationModalOpen);
    setLocationModalOpen(flag);
  };

  const handleDelete = (e: any, infoType: string) => {
    console.log("onDelete:", e);
    const keyValue = e.currentTarget.getAttribute("data-key");
    if (infoType == "Cost")
      dispatch(
        deleteCostInfo({
          key: "Costs",
          value: keyValue,
        })
      );
    if (infoType == "Location")
      dispatch(
        deleteLocationInfo({
          key: "Locations",
          value: keyValue,
        })
      );
  };

  const cancelEvent = () => {
    // dispatch(changeCurrentMemberMenu(screenConfig.eventList));
    navigate(routeConfig.EVENT_URL, { replace: false });
  };

  const color1 = "#2d6289";

  // const muiTextFieldTheme
  const muiDatePickerColorTheme = (theme: any) =>
    createTheme({
      ...theme,
      palette: {
        primary: {
          main: color1,
        },
        secondary: {
          main: color1,
        },
        // error: {
        //   main: color1,
        // },
      },
      components: {
        MuiIconButton: {
          styleOverrides: {
            sizeMedium: {
              color1,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 0,
            },
            notchedOutline: {
              borderWidth: 0,
              // borderBottomStyle: "solid",
              // borderBottomWidth: 1,
              boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.05) inset",
            },
            input: {
              height: "0.8rem",
              background: "var(--form-input-background-color)",
              paddingTop: "20px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "0px",
              fontWeight: "500",
            },
          },
        },
        MuiDatePicker: {
          styleOverrides: {
            root: {
              margin: "normal",
            },
          },
        },
        MuiInputLabel: {
          styleOverrides: {
            root: {
              color: color1,
              zIndex: 1,
            },
          },
        },
        MuiFormLabel: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              color: color1,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              background: "var(--form-input-background-color)",
            },
          },
        },
        MuiTextField: {
          styleOverrides: {
            root: {
              // marginBottom: "1.8rem",
            },
          },
        },
      },
    });

  const onProgress = (data: any) => {
    setUploaded(Math.round((data.loaded / data.total) * 100));
  };

  const uploadMaterial = async (file: File) => {
    console.log("uploadMaterial CALLED:", eventInfo);
    setMaterialUploadModalOpen(true);
    const formData = new FormData();
    formData.append("media", file);
    formData.append("id", "1");

    if (eventInfo.UniqueEventId) {
      const response = await EventServices.UploadMaterial(
        formData,
        eventInfo.UniqueEventId,
        onProgress
      );
      console.log("response", response);
      // setvideoURL(response?.data.data.media_url);

      dispatch(
        updateEvent({
          key: "MaterialLink",
          value: response?.data.data.media_url,
        })
      );
    } else {
      alert("Please enter event id");
      return;
    }
  };

  return (
    <div className="dashboard-content-wrapper" style={{ marginBottom: "20px" }}>
      <ToastContainer />
      <div className="horizontal-wrapper-spacebetween">
        <h1 className="page-heading">Create Event</h1>
        <div
          style={{ cursor: "pointer", paddingRight: "0rem", color: "blue" }}
          onClick={cancelEvent}
        >
          <PageLink>Cancel </PageLink>
        </div>
      </div>
      <form
        key={1}
        className="form-wrapper"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        {/* ----------Event Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Event Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="EventName"
                {...register("EventName", {
                  required: "* required field",
                })}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="EventName">
                Event Name
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.EventName?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="UniqueEventId"
                {...register("UniqueEventId", {
                  required: "* required field",
                })}
                value={uniqueEventId}
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="UniqueEventId">
                Event ID
              </label>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.UniqueEventId?.message}
              </p>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-medium">
              <select
                className="dropdown-control-large-insidetextfield"
                id="EventType"
                // placeholder=""
                style={{ color: "#25284e" }}
                {...register("EventType", {
                  required: "* is a required field",
                })}
                onChange={(e) => {
                  updateInput(e);
                }}
              >
                <option value={""}> Select Type </option>
                <option value="Function">Function</option>
                <option value="Seminar">Seminar</option>
              </select>
              <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.EventType?.message}
              </p>
            </div>
            <div className="input-field-div-wrapper-medium">
              <Controller
                control={control}
                name="StartDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="Start Date"
                        value={dayjs(value)}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.StartDateTime?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          date && setStartDateTime(date);
                          updateDateField(date, "StartDateTime");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper-medium">
              <Controller
                control={control}
                name="EndDateTime"
                rules={{ required: "* required field" }}
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="End Date"
                        value={dayjs(value)}
                        minDate={StartDateTime}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.EndDateTime?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          date && setEndDateTime(date);
                          updateDateField(date, "EndDateTime");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>

            <div className="input-field-div-wrapper-medium">
              <Controller
                control={control}
                name="EarlyBirdBy"
                render={({
                  field: { onChange, onBlur, value, name, ref },
                  fieldState: { error },
                }) => (
                  <ThemeProvider theme={muiDatePickerColorTheme}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DateTimePicker
                        className="datepicker-local"
                        label="Early Bird By"
                        value={dayjs(value)}
                        maxDate={StartDateTime}
                        slotProps={{
                          textField: {
                            error: Boolean(error),
                            helperText: error
                              ? errors.EarlyBirdBy?.message?.toString()
                              : "",
                          },
                        }}
                        onChange={(date: any) => {
                          date && setEarlyBirdBy(date);
                          updateDateField(date, "EarlyBirdBy");
                        }}
                      />
                    </LocalizationProvider>
                  </ThemeProvider>
                )}
              />
            </div>
          </div>

          <div className="textarea-wrapper" style={{ width: "100%" }}>
            <TextField
              className="textarea"
              id="Description"
              name="Description"
              placeholder="Event Description"
              multiline
              rows={3}
              onChange={(e) => {
                updateTextField(e);
              }}
            />
          </div>
          {/* <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-large">
              <label className="form-label" htmlFor="uploadMaterial">
                Upload Material
              </label>
              <input
                style={{ left: "9rem", width: "auto" }}
                type="file"
                className="input-field-div-small pt-2"
                placeholder="Upload Material File"
                id="material"
                name="material"
                // onChange={(e) => {
                //   uploadMaterial(e);
                // }}
              />
            </div>

            <div className="input-field-div-wrapper-large">
              <input
                className="input-field-div-small"
                placeholder=""
                id="MaterialLink"
                name="MaterialLink"
                autoComplete="off"
                readOnly={true}
                value={materialURL}
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="MaterialLink">
                Material Link
              </label>
            </div>
          </div> */}

          <div
            className="horizontal-wrapper-spacebetween"
            style={{ marginBottom: "1.4rem" }}
          >
            <div
              className="vertical-wrapper"
              style={{
                width: "45%",
              }}
            >
              <div
                className="input-field-div-wrapper-large"
                style={{ width: "100%" }}
              >
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="SponsorName"
                  name="SponsorName"
                  autoComplete="off"
                  onChange={(e) => {
                    updateInput(e);
                  }}
                />
                <label className="form-label" htmlFor="SponsorName">
                  Sponsor
                </label>
              </div>
              <div
                className="input-field-div-wrapper-large"
                style={{ width: "100%" }}
              >
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="RegistrationLink"
                  name="RegistrationLink"
                  // {...register("RegistrationLink", {
                  //   required: "* required field",
                  // })}
                  autoComplete="off"
                  readOnly={true}
                  value={registrationLink}
                  // onChange={(e) => {
                  //   updateInput(e);
                  // }}
                />
                <label className="form-label" htmlFor="RegistrationLink">
                  Registration Link
                </label>
                {/* <p
                className="form-error"
                style={{ position: "absolute", top: "100%", marginTop: "0" }}
              >
                {errors.RegistrationLink?.message}
              </p> */}
              </div>
            </div>
            <div
              className="input-field-div-wrapper"
              style={{ marginTop: "1rem", width: "45%" }}
            >
              <input
                className="input-field-div-small"
                placeholder=""
                id="MaterialLink"
                name="MaterialLink"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="MaterialLink">
                Material Link
              </label>
            </div>
          </div>

          <div className="horizontal-wrapper-spacebetween">
            {eventType !== "Video" ? (
              <>
                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="ZoomMeetingID"
                    name="ZoomMeetingID"
                    autoComplete="off"
                    onChange={(e) => {
                      updateInput(e);
                    }}
                  />
                  <label className="form-label" htmlFor="ZoomMeetingID">
                    Zoom Meeting ID
                  </label>
                </div>
                <div className="input-field-div-wrapper-large">
                  <input
                    className="input-field-div-small"
                    placeholder=""
                    id="ZoomRegLink"
                    name="ZoomRegLink"
                    autoComplete="off"
                    onChange={(e) => {
                      updateInput(e);
                    }}
                  />
                  <label className="form-label" htmlFor="ZoomRegLink">
                    Zoom Meeting Link
                  </label>
                </div>{" "}
              </>
            ) : (
              <></>
            )}

            {/* && videoURL === null ? (
              true
            ) : false */}

            {/* {eventType === "Video" && videoURL === null ? (
              <>
                <div className="input-field-div-wrapper-large">
                  <input
                    type="file"
                    className="input-field-div-small"
                    placeholder=""
                    id="videos"
                    name="videos"
                    accept=".mp4, .mkv"
                    onChange={(e) => {
                      uploadVideo(e);
                    }}
                  />
                </div>
              </>
            ) : (
              <></>
            )}
            {eventType === "Video" && videoURL !== null ? (
              <div className="input-field-div-wrapper-large">
                <input
                  className="input-field-div-small"
                  placeholder=""
                  id="videoURL"
                  name="videoURL"
                  autoComplete="off"
                  readOnly={true}
                  value={videoURL!}
                />
                <label className="form-label" htmlFor="videoURL">
                  Video Link
                </label>
              </div>
            ) : (
              <></>
            )}
            {eventType === "Video" ? (
              <div className="input-field-div-wrapper-smaller">
                <CurrencyInput
                  className="input-field-div-small"
                  id="VideoCost"
                  placeholder=""
                  name="VideoCost"
                  decimalsLimit={2}
                  onChange={(e) => {
                    updateTextField(e);
                  }}
                />
                <label className="form-label" htmlFor="Cost">
                  Cost
                </label>
              </div>
            ) : (
              <></>
            )} */}
          </div>
        </div>
        {/* ----------Credit Information------------ */}
        <div className="section-box">
          <h3 className="section-heading">Credit Information</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DECredits"
                name="DECredits"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="DECredits">
                DE Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="DEEnchEthics"
                name="DEEnchEthics"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="DEEnchEthics">
                DE Ethics
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PACredits"
                name="PACredits"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="PACredits">
                PA Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="PAEthics"
                name="PAEthics"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="PAEthics">
                PA Ethics
              </label>
            </div>
          </div>
          <div className="horizontal-wrapper-spacebetween">
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJCredits"
                name="NJCredits"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="NJCredits">
                NJ Credits
              </label>
            </div>
            <div className="input-field-div-wrapper-smaller">
              <input
                className="input-field-div-small"
                type="number"
                placeholder=""
                id="NJEthics"
                name="NJEthics"
                autoComplete="off"
                onChange={(e) => {
                  updateInput(e);
                }}
              />
              <label className="form-label" htmlFor="NJEthics">
                NJ Ethics
              </label>
            </div>
          </div>
        </div>

        {/* ----------Availability Settings------------ */}
        <div className="section-box">
          <h3 className="section-heading">Availability Settings</h3>
          <div className="horizontal-wrapper-spacebetween">
            <div className="form-group">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="AvailableOnline"
                  name="AvailableOnline"
                  checked={eventInfo.AvailableOnline === 1}
                  onChange={(e) => updateInput(e)}
                />
                <label
                  className="form-check-label"
                  htmlFor="AvailableOnline"
                >
                  Available for registration
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="horizontal-wrapper-spacebetween">
          {/* ----------Cost Information------------ */}
          <div className="section-box" style={{ width: "48%" }}>
            <div className="horizontal-wrapper-spacebetween">
              <h3 className="section-heading">Cost Information</h3>
              <PageLink onClick={() => setCostModalOpen(true)}>
                <span>+ADD</span>
              </PageLink>
            </div>
            <div className="horizontal-wrapper-spacebetween">
              {eventInfo.Costs != null ? (
                eventInfo.Costs!.map((eventcostitem: any) => (
                  <div
                    className="form-wrapper-space-around "
                    key={eventcostitem.Id}
                  >
                    <div className="cost-name-extralarge">
                      {eventcostitem.CostName as string}
                    </div>
                    <div className="cost-name-smaller">
                      {eventcostitem.Cost as number}
                    </div>
                    <img
                      style={{
                        width: "1rem",
                        height: "1.2rem",
                        alignSelf: "center",
                      }}
                      src={deleteIcon}
                      alt="Del"
                      data-key={eventcostitem.Id}
                      onClick={(e) => {
                        handleDelete(e, "Cost");
                      }}
                    />
                  </div>
                ))
              ) : (
                <>--</>
              )}
            </div>
          </div>

          {/* ----------Location Information------------ */}
          <div className="section-box" style={{ width: "48%" }}>
            <div className="horizontal-wrapper-spacebetween">
              <h3 className="section-heading">Location Information</h3>
              <PageLink onClick={() => setLocationModalOpen(true)}>
                <span>+ADD</span>
              </PageLink>
            </div>
            <div className="horizontal-wrapper-spacebetween">
              {eventInfo.Locations != null ? (
                eventInfo.Locations!.map((eventlocationitem) => (
                  <div
                    className="form-wrapper-space-around "
                    key={eventlocationitem.Id}
                  >
                    <div className="cost-name-extralarge">
                      {eventlocationitem.Location as string}
                    </div>
                    {/* <div className="cost-name-smaller">
                        {eventlocationitem.Cost as number}
                      </div> */}
                    <img
                      style={{
                        width: "1rem",
                        height: "1.2rem",
                        alignSelf: "center",
                      }}
                      src={deleteIcon}
                      alt="Del"
                      data-key={eventlocationitem.Id}
                      onClick={(e) => {
                        handleDelete(e, "Location");
                      }}
                    />
                  </div>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
        {/* ----------Submit button Information------------ */}
        <div className="horizontal-wrapper-centeralign">
          <Button
            className="submit-button-div"
            type="submit"
            // disabled={eventType === "Video" && videoURL === null ? true : false}
            onClick={() => {
              console.log("onclick called", StartDateTime);
              if (StartDateTime === null || EndDateTime === null) {
                alert("Please enter event start date and end date");
              }
            }}
          >
            Create Event
          </Button>
        </div>
      </form>
      {/* cost modal */}
      <ReactModal
        isOpen={CostModalOpen}
        // onRequestClose={() => setCostModalOpen(false)}
        className="editinfo-modal-large overflow-y-auto"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Cost Information
          </h1>
          <PageLink
            onClick={() => setCostModalOpen(false)}
            style={{ marginBottom: "2rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <AddCostInfo closeCostModal={closeCostModal} />
      </ReactModal>

      {/* Location modal */}
      <ReactModal
        isOpen={LocationModalOpen}
        // onRequestClose={() => setLocationModalOpen(false)}
        className="editinfo-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Add Location Information
          </h1>
          <div className="d-flex">
            <span
              className="secondary-button me-4"
              onClick={() => openAddLocationDialog()}
            >
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add New Location</span>
            </span>
            <PageLink
              onClick={() => setLocationModalOpen(false)}
              style={{ marginBottom: "2rem" }}
            >
              Cancel
            </PageLink>
          </div>
        </div>
        <AddLocationInfo
          closeAddLocationDialog={closeAddLocationDialog}
          addLocationDialogOpen={addLocationDialogOpen}
          setAddLocationDialogOpen={setAddLocationDialogOpen}
          closeLocationModal={closeLocationModal}
        />
      </ReactModal>

      {/* Video Upload progress */}
      {/* <ReactModal
        isOpen={videoUploadModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            Video Upload Inprogress
          </h1>
        </div>
        <div className="uploadPercent" style={{ width: "10%", height: "100%" }}>
          <Typography variant="h3" color="secondary">
            {uploaded}%
          </Typography>
        </div>
        <div
          className="uploadProgress"
          style={{ width: "90%", height: "100%", marginBottom: "2rem" }}
        >
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={uploaded}
          />
        </div>

        <div className="button-wrapper">
          <div className="submit-button-div">
            <Button
              type="submit"
              disabled={videoURL !== null ? false : true}
              onClick={() => setvideoUploadModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </ReactModal> */}

      {/* Material Upload progress */}
      <ReactModal
        isOpen={materialUploadModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "2rem", zIndex: "20", height: "5%" }}
        >
          <h1
            className="page-heading"
            // style={{ marginBottom: "2rem", }}
          >
            {materialURL === null
              ? "Video Upload Inprogress"
              : "Upload Complete"}
          </h1>
        </div>
        <div className="uploadPercent" style={{ width: "10%", height: "100%" }}>
          <Typography variant="h3" color="secondary">
            {uploaded}%
          </Typography>
        </div>
        <div
          className="uploadProgress"
          style={{ width: "90%", height: "100%" }}
        >
          <LinearProgress
            variant="determinate"
            color="secondary"
            value={uploaded}
          />
        </div>

        <div className="button-wrapper" style={{ marginTop: "1rem" }}>
          <div className="submit-button-div">
            <Button
              type="submit"
              disabled={materialURL === null ? true : false}
              onClick={() => setMaterialUploadModalOpen(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </ReactModal>
      <ReactModal
        isOpen={YesNoAlertModalOpen}
        className="saveSearchModal"
        overlayClassName="overlay"
      >
        <YesNoAlert callBack={deleteMaterialURL} />
      </ReactModal>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CreateEvent;
